import './style.css';
import { useEffect, useState } from 'preact/hooks';
import { RATING_TYPE } from '../../constants';
import StarRating from './Components/StarRating';
import NumberRating from './Components/NumberRating';
import ThumbRating from './Components/ThumbRating';
import EmojiRating from './Components/EmojiRating';

const RatingField = ({ fieldData, csatForm, setCSATForm, required }) => {
  const [rating, setRating] = useState(0);
  const [ratingComment, setRatingComment] = useState('');
  const [isRequired, setIsRequired] = useState(false);
  const [isFollowUpRequired, setIsFollowUpRequired] = useState(false);

  const handleRating = (rate, fieldId) => {
    if (fieldId === fieldData.Id) {
      setRating(rate);
    }
  };

  useEffect(() => {
    csatForm.FormFields.map((field) => {
      if (field.Id === fieldData.Id) {
        fieldData['value'] = rating;
        fieldData['comment'] = ratingComment;
      }
      return csatForm;
    });
    setCSATForm(csatForm);
  }, [rating, ratingComment]);

  useEffect(() => {
    setIsRequired(required.hasOwnProperty(fieldData.Id));
    setIsFollowUpRequired(required.hasOwnProperty(`${fieldData.Id}followup`));
  }, [required]);

  return (
    <div>
      <div className="ratingWrapper">
        <div className="title">
          {fieldData.RatingField.Title}
          {isRequired && <span className="required"> * required</span>}
          {!fieldData.IsMandatory ? <span> (optional)</span> : ''}
        </div>
        <div className="ratingField">
          {fieldData.RatingField.Type === RATING_TYPE.STAR && (
            <StarRating
              id={fieldData.Id}
              ratingScore={rating}
              setRatingScore={handleRating}
            />
          )}
          {fieldData.RatingField.Type === RATING_TYPE.NUMBER && (
            <NumberRating
              id={fieldData.Id}
              ratingScore={rating}
              setRatingScore={handleRating}
            />
          )}
          {fieldData.RatingField.Type === RATING_TYPE.EMOJI && (
            <EmojiRating
              id={fieldData.Id}
              ratingScore={rating}
              setRatingScore={handleRating}
            />
          )}
          {fieldData.RatingField.Type === RATING_TYPE.THUMB && (
            <ThumbRating
              id={fieldData.Id}
              ratingScore={rating}
              setRatingScore={handleRating}
            />
          )}
        </div>
      </div>
      {fieldData.RatingField.Question.map((ques) => {
        if (rating === ques.Score)
          return (
            <div className="followUp">
              <div className="title">
                {ques.Title}
                {isFollowUpRequired && (
                  <span className="required"> * required</span>
                )}
                {fieldData.RatingField.IsFollowUpMandatory &&
                rating <= fieldData.RatingField.MinScoreForFollowUp ? (
                  ''
                ) : (
                  <span> (optional)</span>
                )}
              </div>
              <textarea
                id={fieldData.Id}
                rows={4}
                className="textarea"
                placeholder={ques.Placeholder}
                value={ratingComment}
                onChange={(e) => setRatingComment(e.target.value)}
              />
            </div>
          );
        return null;
      })}
    </div>
  );
};

export default RatingField;
